import { SpecimenResource } from '@skinsoft/types'
import { specimenSelectors } from '@skinsoft/selectors'

export const byRealTimeLocation = (a: SpecimenResource, b: SpecimenResource) => {
    const aRealTimeLocation = specimenSelectors.realTimeLocation(a as SpecimenResource) || '';
    const bRealTimeLocation = specimenSelectors.realTimeLocation(b as SpecimenResource) || '';
    return bRealTimeLocation.localeCompare(aRealTimeLocation);
};
